import { styled } from '@mui/material';
import { Alert as MuiAlert } from '@mui/material';
import * as React from 'react';

export interface FormMessage {
  type: 'ERROR' | 'INFO';
  text: string;
}

export interface AlertBoxProps {
  messages: FormMessage[];
  onMessageDismiss: (i: number) => void;
}

const Alert = styled(MuiAlert)({
  marginBottom: 5,
});

export const AlertBox: React.FC<AlertBoxProps> = (props) => {
  return (
    <>
      {props.messages.map((message, i) => (
        <Alert key={i} onClose={() => props.onMessageDismiss(i)} severity="error">
          {message.text}
        </Alert>
      ))}
    </>
  );
};
